<script setup lang="ts">
import SVG from '@/components/shared/SVG.vue';
import BaseOverlay from '@/overlays/BaseOverlay.vue';

const emit = defineEmits(['close']);

type Item = {
  picture?: {
    source: string;
  };
  title: string;
};

interface Props {
  items: Item[];
  title: string;
}

defineProps<Props>();
</script>

<template>
  <BaseOverlay @close="emit('close')" :title="title">
    <template #content>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="inline-flex w-full pb-10 items-center"
      >
        <img
          v-if="item.picture"
          :src="item.picture.source"
          :class="{ '-m-1': index !== 0 }"
          class="w-24 h-24 rounded-full border-4 shadow-small border-white mr-10"
          v-optimized="{ src: item.picture.source, size: 'small' }"
        />
        <div
          v-else
          :class="{ '-m-1': index !== 0 }"
          class="w-24 h-24 mr-10 flex items-center justify-center bg-white rounded-full border-4 shadow-small border-white"
        >
          <SVG
            class="text-neutral-700"
            icon="fas-tag"
            height="40"
            width="48"
          ></SVG>
        </div>

        <p class="label">
          {{ item.title }}
        </p>
      </div>
    </template>
  </BaseOverlay>
</template>
